import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DeploymentState, Deployment } from './deploymentTypes';
import { deploymentAPI } from './deploymentAPI';

const initialState: DeploymentState = {
  deployments: [],
  currentDeployment: null,
  loading: false,
  error: null,
};

const deploymentSlice = createSlice({
  name: 'deployment',
  initialState,
  reducers: {
    setCurrentDeployment: (state, action: PayloadAction<Deployment | null>) => {
      state.currentDeployment = action.payload;
    },
    clearDeploymentError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      deploymentAPI.endpoints.getDeployments.matchPending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    );
    builder.addMatcher(
      deploymentAPI.endpoints.getDeployments.matchFulfilled,
      (state, action) => {
        state.loading = false;
        state.deployments = action.payload;
      }
    );
    builder.addMatcher(
      deploymentAPI.endpoints.getDeployments.matchRejected,
      (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message || 'Failed to fetch deployments';
      }
    );
    
    builder.addMatcher(
      deploymentAPI.endpoints.createDeployment.matchFulfilled,
      (state, action) => {
        state.deployments.unshift(action.payload);
        state.currentDeployment = action.payload;
      }
    );
  },
});

export const { setCurrentDeployment, clearDeploymentError } = deploymentSlice.actions;
export default deploymentSlice.reducer;
